import React from "react";
import "./projectionsCard.css";



function getImpactClass(score) {
  if (!score) return "";
  if (score < 5) return "red_impact";
  if (score < 7) return "orange_impact";
  return "green_impact";
}

const ProjectionsCards = ({ nudgeData }) => {
  return (
    <>
     <div className="sideCardContentTitle">Projections</div>
    
    
   
    <div className="projections-wrapper mb-2">
     
      <div className="projections-subtitle">Key projections for this opportunity</div>
      
      <div className="metrics-grid">
        <div className="metric-card primary-card">
          <div className="metric-header">
            {/* <TamIcon /> */}
            <span>Total Addressable Market</span>
          </div>
          <div className="metric-value">
            {nudgeData?.opportunity_size || "N/A"}
          </div>
          <div className="metric-description">
            Estimated maximum market potential
          </div>
        </div>
        
        {nudgeData?.impact_score && (
          <div className={`metric-card ${getImpactClass(nudgeData.impact_score)}`}>
            <div className="metric-header">
              {/* <ImpactIcon /> */}
              <span>Impact Score</span>
            </div>
            <div className="metric-value">
              {nudgeData.impact_score}%
              <div className="score-trend">
                {nudgeData.impact_score >= 7 ? "↑ High" : 
                 nudgeData.impact_score >= 5 ? "→ Medium" : "↓ Low"}
              </div>
            </div>
            <div className="metric-description">
              Projected impact on revenue
            </div>
          </div>
        )}

      </div>
    </div>
    </>
  );
};

export default ProjectionsCards;